import { lazy } from "react";

export const InfoBar = lazy(() => import("./InfoBarContainer"));
